module.exports = __webpack_public_path__ + "img/txt_info4.53a3dffc.png";